module.exports = __webpack_public_path__ + "static/media/IMG_4663.f986465b.JPG";